module.exports = __webpack_public_path__ + "static/media/15.99492839.jpg";